import React from 'react';
import './App.css';
import Viz from './Viz';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <Viz />
      </header>
    </div>
  );
}

export default App;
